<template>
    <div class="flex gap-x-5 items-center flex-wrap justify-center">
        <div v-if="showAll || showAlwaysPossible || showSpecific.some(x => x == 'card')" class="flex gap-2 items-center h-[50px]">
            <AmericanExpressIcon v-if="locale != 'da-DK'"/>
            <MastercardIcon/>
            <VisaIcon/>
        </div>
        <div v-if="showAll || showSpecific.some(x => x == 'customer_balance')" class="flex gap-1 items-center h-[50px]">
            <div class="bg-gray-200 p-1 rounded border border-gray-400">
                <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 512 512">
                <path fill="#565656"
                        d="m243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24h400c13.3 0 24-10.7 24-24v-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0M128 224H64v196.3c-.6.3-1.2.7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512h448c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V224H384v192h-40V224h-64v192h-48V224h-64v192h-40zM256 64a32 32 0 1 1 0 64a32 32 0 1 1 0-64"/>
                </svg>
            </div>
            <span class="tracking-normal font-bold">{{ getText(14136) }}</span>
        </div>
        <div v-if="showAll || showSpecific.some(x => x == 'sepa_debit')" 
            class="flex gap-2 items-center h-[50px]">
            <SEPAIcon/>
        </div>
        <div v-if="showAll || showSpecific.some(x => x == 'mobilepay')" style="margin: 0 -15px;">
            <MobilePayIcon/>
        </div>
        <div v-if="showAll || showSpecific.some(x => x == 'ideal')"  class="flex gap-2 items-center h-[50px]">
            <IDealIcon/>
        </div>
        <ApplePayIcon v-if="showAll || showAlwaysPossible || showSpecific.some(x => x == 'card')"/>
        <GooglePayIcon v-if="showAll || showAlwaysPossible || showSpecific.some(x => x == 'card')"/>
    </div>
</template>

<script setup lang="ts">
import { getText } from '@/services/translation.service';
import SEPAIcon from './Icons/SEPAIcon.vue';
import MobilePayIcon from './Icons/MobilePayIcon.vue';
import IDealIcon from './Icons/iDealIcon.vue';
import VisaIcon from './Icons/VisaIcon.vue';
import MastercardIcon from './Icons/MastercardIcon.vue';
import ApplePayIcon from './Icons/ApplePayIcon.vue';
import GooglePayIcon from './Icons/GooglePayIcon.vue';
import AmericanExpressIcon from './Icons/AmericanExpressIcon.vue';
import { ref, onMounted } from 'vue';

const locale = ref("");
onMounted(() => {
    locale.value = document.documentElement.lang
})

const {
    showAll = false,
    showSpecific = [],
    showAlwaysPossible = false
} = defineProps<{
    showAll?: boolean,
    showSpecific?: string[],
    showAlwaysPossible?: boolean
}>()
</script>

<style scoped></style>